import { render } from "./PrivacyAndPolicy.vue?vue&type=template&id=26f848a8&scoped=true"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"

import "./PrivacyAndPolicy.vue?vue&type=style&index=0&id=26f848a8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f848a8"]])

export default __exports__